<template>
  <div>
    <div class="main-box">
      <h2>【重要提示】</h2>
      <div class="prompt_lang">
        <p>
          1、设置试卷独立密码后，可以对试卷进行加密操作，已加密试卷需要解密后才可进行操作；
        </p>
        <p>
          2、在“试题管理”中开启试题保护后，试题管理内的自主试题需验证独立密码后才可使用；
        </p>
        <p>
          3、由于加密的不可逆，若遗忘独立密码，所加密的试卷/试题将不能恢复(只能删除)，请务必牢记独立密码。
        </p>
      </div>
      <div class="oper_prompt">您已设置过独立密码，请选择操作。</div>
      <!-- 输入框 -->
      <div class="modify_box">
        <h3>修改独立密码</h3>
        <el-form
          :model="loginForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="password_box">
            <div class="password_input">
              <el-form-item label="验证旧独立密码：" prop="account">
                <div>
                  <el-input
                    placeholder="请输入旧独立密码"
                    v-model.trim="loginForm.account"
                    :type="flag ? 'password' : 'text'"
                    autocomplete="off"
                  >
                    <template>
                      <i
                        slot="suffix"
                        class="iconfont"
                        :class="flag ? 'icon-yincangmima' : 'icon-eyes'"
                        @click="flag = !flag"
                      ></i>
                    </template>
                  </el-input>
                  <span class="isError" v-show="isError">密码错误</span>
                </div>
              </el-form-item>
            </div>
            <div class="password_input">
              <div>
                <el-form-item label="新独立密码：" prop="password">
                  <el-input
                    placeholder="6-20位，支持英文数字符号"
                    v-model.trim="loginForm.password"
                    :type="flag1 ? 'password' : 'text'"
                    autocomplete="off"
                  >
                    <template>
                      <i
                        slot="suffix"
                        class="iconfont"
                        :class="flag1 ? 'icon-yincangmima' : 'icon-eyes'"
                        @click="flag1 = !flag1"
                      ></i> </template
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="password_input">
              <el-form-item label="再次输入：" prop="confirmPassword">
                <el-input
                  placeholder="请再次输入密码"
                  v-model.trim="loginForm.confirmPassword"
                  :type="flag2 ? 'password' : 'text'"
                  autocomplete="off"
                >
                  <template>
                    <i
                      slot="suffix"
                      class="iconfont"
                      :class="flag2 ? 'icon-yincangmima' : 'icon-eyes'"
                      @click="flag2 = !flag2"
                    ></i> </template
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 按钮操作 -->
    <div class="operation">
      <el-button size="mini" @click="toHome">返回</el-button>
      <el-button size="mini" @click="cryptopwd">保存</el-button>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import { validationPaw, validatePass, validatePass2 } from "@/utils/validata";
import loginvuex from "@/store/index";
import md5 from "js-md5";
import { updateCryptoPwd } from "@/api/examination.js";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      loginForm: {
        account: "",
        password: "",
        confirmPassword: "",
      },
      isError: false, // 密码错误提示框
      flag: true, // input查看隐藏密码的矢量图
      flag1: true,
      flag2: true,
      rules: {
        account: [{ validator: validationPaw, trigger: "blur" }],
        password: [{ validator: validatePass(this), trigger: "blur" }],
        confirmPassword: [{ validator: validatePass2(this), trigger: "blur" }],
      },
    };
  },
  methods: {
    // 取消返回首页
    toHome() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:ModifyThe:tab1:back",
          parent_code: "PersonalCenter:ModifyThe",
        },
        "statetime"
      );
      this.$router.push("/papers");
    },
    //修改密码
    async cryptopwd() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:ModifyThe:tab1:save",
          parent_code: "PersonalCenter:ModifyThe",
        },
        "statetime"
      );
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        newCryptoPwd: md5(this.loginForm.confirmPassword), // 旧密码
        oldCryptoPwd: md5(this.loginForm.account), // 新密码
      };
      const Data = await updateCryptoPwd(params);
      if (Data.data.Status === 200) {
        this.$message({
          message: "恭喜你，修改密码成功",
          type: "success",
        });
        this.loginForm = "";
        //  this.$router.go(0)  // 强制刷新一遍
      } else {
        this.$message.error(Data.data.Data);
        this.isError = true;
      }
      console.log(Data.data.Status, "状态哦");
      console.log(Data.data.count, "状态哦");
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  // border: 1px solid #000;
  min-width: 1600px;
  margin-top: 50px;
  h2 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 21px;
    color: #333333;
    opacity: 1;
  }
  .prompt_lang {
    margin-top: 30px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 36px;
    // color: #ff0000;
    opacity: 1;
    p:nth-last-child(1) {
      color: #ff0000;
    }
  }
  .oper_prompt {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 21px;
    color: #333333;
    opacity: 1;
    margin: 30px 0 30px 0;
  }
  .modify_box {
    width: 660px;
    height: 414px;
    background: #ffffff;
    box-shadow: 0px 3px 15px #d8edff;
    opacity: 1;
    border-radius: 10px;
    h3 {
      height: 58px;
      color: #ffffff;
      font-size: 18px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 58px;
      background: #1890ff;
      opacity: 1;
      border-radius: 10px 10px 0px 0px;
    }
    .password_box {
      padding: 40px 30px 60px 30px;
      .password_input {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        p {
          width: 120px;
          height: 24px;
        }

        > div {
          p {
            width: 100% !important;
            margin-left: 102px;
            font-size: 13px;
          }
        }
        ::v-deep .el-input--suffix .el-input__inner {
          width: 450px;
          height: 56px !important;
        }
      }
    }
  }
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0 186px 0;

  .el-button {
    width: 162px;
    height: 50px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #ffffff;
    opacity: 1;
  }
  .el-button:nth-child(1) {
    background: #eeeeee;
    color: #999999;
  }

  .el-button:nth-child(2) {
    margin-left: 90px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-form-item__content {
  margin-left: 128px !important;
}
::v-deep .el-form-item__label {
  width: 128px !important;
  text-align: left;
}
::v-deep .el-input__suffix {
  right: 16px;
  top: 8px;
  i {
    font-size: 22px;
    display: inline-block;
  }
  i:nth-of-type(1) {
    margin-left: 12px;
  }
  i:nth-child(2) {
    display: none;
  }
}
.isError {
  color: #ff0000 !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  opacity: 1;
}
</style>